/*
 * File: cell-html-string.ts
 * File Created: 2023-12-18 04:51:11
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 08:50:23
 * Modified By: Val Liu
 * -----
 */

import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseTableBodyCell } from "../../../core/lib/base-table-body-cell/base-table-body-cell";
import { AnyHelper, DateHelper, NumberHelper } from "@root/core";
import { UITag } from "@root/core/tags";


@Component
@UITag.setDefault({
    uiSort: false,
    uiSearch: false,
})
export default class CellHtmlString extends BaseTableBodyCell {
    private render(h) {
        return Vue.compile(this.value).render.call(this, h);
    }
}
